/**
 * [INPUT]: 依赖 AppSidebar、PagePanel、各业务页
 * [OUTPUT]: 对外提供 MainLayout（componentMap + 唯一 PagePanel 滚动根）
 * [POS]: layouts 桌面外壳，被 App 认证路由消费
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import AppSidebar from '@/components/AppSidebar'
import Dashboard from '@/pages/Dashboard'
import { PageLoading } from '@/components/LoadingDots'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/zinnercms-design-system/ui/sidebar'
import { PagePanel } from '@/zinnercms-design-system/patterns/page'

const componentMap = {
  '/zinner/users': lazy(() => import('@/pages/zinner/Users')),
  '/zinner/prospects': lazy(() => import('@/pages/zinner/Prospects')),
  '/zinner/date-logs': lazy(() => import('@/pages/zinner/DateLogs')),
  '/zinner/topics': lazy(() => import('@/pages/zinner/Topics')),
  '/zinner/sms': lazy(() => import('@/pages/zinner/Sms')),
}

function DynamicPage() {
  const location = useLocation()
  const Comp = componentMap[location.pathname]
  if (!Comp) return <Navigate to="/admin/dashboard" replace />
  return <Comp />
}

export default function MainLayout() {
  const location = useLocation()

  return (
    <SidebarProvider>
      <div className="flex h-dvh min-h-0 w-full overflow-hidden bg-sidebar text-foreground">
        <AppSidebar />
        <SidebarInset className="flex h-dvh min-w-0 flex-1 flex-col overflow-hidden !m-0 !rounded-none !border-0 !bg-transparent !p-0 !shadow-none">
          <div className="relative flex min-h-0 min-w-0 flex-1 flex-col py-2 pr-2 pl-0 sm:py-3 sm:pr-3 sm:pl-0">
            <div className="absolute top-4 left-3 z-30 flex size-9 items-center justify-center rounded-xl border border-border/80 bg-card shadow-xs md:hidden">
              <SidebarTrigger className="size-8 rounded-lg" aria-label="打开主导航" />
            </div>
            <PagePanel panelKey={location.pathname} viewportClassName="pt-14 md:pt-5 lg:pt-6">
              <Suspense fallback={<PageLoading message="加载中" />}>
                <Routes location={location}>
                  <Route index element={<Navigate to="/admin/dashboard" replace />} />
                  <Route path="/admin/dashboard" element={<Dashboard />} />
                  <Route path="/zinner/*" element={<DynamicPage />} />
                  <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                </Routes>
              </Suspense>
            </PagePanel>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}
